import { render, staticRenderFns } from "./Giv.vue?vue&type=template&id=02936720&"
import script from "./Giv.vue?vue&type=script&lang=js&"
export * from "./Giv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports